/* Auto-scroll for a product carousel (snippets/st-autoscroll.liquid says when and why). Moves the
   carousel's own scroller one card on with a smooth scroll, so Horizon's slideshow follows as it
   does for a swipe, and returns to the first card after the last. Holds on hover, focus, off screen
   and a hidden tab; stops for good on the shopper's own scroll, swipe, wheel, keys or arrows, until
   they press play. Nothing runs under reduced motion. */
if (!customElements.get('st-autoscroll')) {
  customElements.define(
    'st-autoscroll',
    class extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const seconds = Number(this.dataset.seconds) || 0;
        const host = this.closest('.section-resource-list') || this.parentElement;
        this.carousel = host?.querySelector('slideshow-component');
        this.scroller = this.carousel?.querySelector('slideshow-slides');
        this.button = this.querySelector('button');
        if (!seconds || !this.scroller || !this.button) return;

        this.abort = new AbortController();
        const { signal } = this.abort;
        this.playing = true;
        this.held = false;
        this.seen = false;

        const stop = () => this.#set(false);
        this.scroller.addEventListener('pointerdown', stop, { signal });
        this.scroller.addEventListener('wheel', (e) => Math.abs(e.deltaX) > Math.abs(e.deltaY) && stop(), { signal, passive: true });
        this.carousel.addEventListener('keydown', stop, { signal });
        this.carousel.addEventListener('click', (e) => e.target.closest?.('button') && stop(), { signal });
        this.carousel.addEventListener('pointerenter', (e) => e.pointerType === 'mouse' && (this.held = true), { signal });
        this.carousel.addEventListener('pointerleave', () => (this.held = this.carousel.matches(':focus-within')), { signal });
        this.carousel.addEventListener('focusin', () => (this.held = true), { signal });
        this.carousel.addEventListener('focusout', () => (this.held = this.carousel.matches(':hover')), { signal });
        this.button.addEventListener('click', () => this.#set(!this.playing), { signal });

        this.observer = new IntersectionObserver(([entry]) => (this.seen = entry.isIntersecting), { threshold: 0.4 });
        this.observer.observe(this.scroller);
        this.timer = setInterval(() => this.#tick(), seconds * 1000);
        this.#set(true);
        this.hidden = this.scroller.scrollWidth <= this.scroller.clientWidth + 2;
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        clearInterval(this.timer);
      }

      #set(on) {
        this.playing = on;
        this.classList.toggle('is-paused', !on);
        this.button.setAttribute('aria-label', on ? this.dataset.pause : this.dataset.play);
      }

      #tick() {
        const s = this.scroller;
        this.hidden = s.scrollWidth <= s.clientWidth + 2;
        if (!this.playing || this.held || !this.seen || document.hidden || this.hidden) return;
        // The carousel's own slides only: each card's photo gallery is a slideshow of its own.
        const slides = [...s.querySelectorAll(':scope > slideshow-slide')].filter((slide) => slide.offsetWidth > 0);
        if (slides.length < 2) return;
        const step = slides[1].offsetLeft - slides[0].offsetLeft;
        if (s.scrollLeft + s.clientWidth >= s.scrollWidth - 2) s.scrollTo({ left: 0, behavior: 'smooth' });
        else s.scrollBy({ left: step, behavior: 'smooth' });
      }
    }
  );
}
